// mode permissions
window.standard = function() {
    return window.config.mode === 0;
}
window.pro = function() {
    return window.config.mode === 1;
}
window.elite = function() {
    return window.config.mode === 2;
}
window.men = function() {
    return window.config.gender_mode === 0;
}
window.women = function() {
    return window.config.gender_mode === 1;
}
window.africaMen = function() {
    return window.config.gender_mode === 2;
}
